export default "__VITE_ASSET__CQFdURXn__"